export default __webpack_public_path__ + "static/media/notification-icon-new.802ab417.svg";